import { render, staticRenderFns } from "./gelf.vue?vue&type=template&id=52eedb6c&"
import script from "./gelf.vue?vue&type=script&lang=js&"
export * from "./gelf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports